export const NUMBER_SIZE_LIMIT_WHEN_ENABLED = 100000000000000;
